<div class="dialog--title" cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane" [cdkDragFreeDragPosition]="position" (cdkDragEnded)="onDragEnded($event)">
  <h6 mat-dialog-title>
    {{ (data.updateConfirmationDialog.title ?? data.sysText.updateConf_title) | titlecase }}
  </h6>
</div>

<mat-dialog-content>
  <div class="subtitle1">
    <p class="body2 first-sentence">{{ data.updateConfirmationDialog.firstSentence ?? data.sysText.updateConf_firstSentence }}</p>
  </div>
  <div>
    @for(message of data.updateConfirmationDialog.messages; track message) {
      <p class="body2">
        <span class="bullet-space">&bull;</span>{{ message }}
      </p>
    }
  </div>
  <div class="subtitle1">
    <p class="body2 last-sentence">{{ data.updateConfirmationDialog.lastSentence ?? data.sysText.updateConf_lastSentence}}</p>
  </div>
</mat-dialog-content>

<!-- Cancel always closes without saving, next to Proceed or the server's actions (e.g. Yes / No to "add supervisor
roles?", which answer that question rather than cancel the save) -->
<mat-dialog-actions align="end">
  <button
    mat-stroked-button
    class="button"
    [mat-dialog-close]="false"
    color="accent">
    {{ data.sysText.cancel }}
  </button>
  @if (data.updateConfirmationDialog.actions?.length > 0) {
    @for (action of data.updateConfirmationDialog.actions; track action) {
      <button
        mat-stroked-button
        class="button"
        color="accent"
        (click)="onAction(action)">
        {{ data.sysText["action_" + action] }}
      </button>
    }
  } @else {
    <button
      mat-stroked-button
      class="button"
      [mat-dialog-close]="true"
      color="accent">
      {{ data.sysText.proceed }}
    </button>
  }
</mat-dialog-actions>
